const Statistics = {
  requestsLastSeenAt: "requestsLastSeenAt",
  reviewsLastSeenAt: "reviewsLastSeenAt",
  landlordsLastSeenAt: "landlordsLastSeenAt",
};

export default Statistics;
